import React, { useState, useEffect } from "react";
import CourierForm from "./form";
import Datatables from "../../../utils/table/datatable";
import { COURIER } from "helpers/url_helper";
import { get } from "helpers/api_helper";

const Couriers = () => {
    const [ isForm , setIsForm ] = useState(false);
    const [ couriers, setCouriers ] = useState([])
    const [ pagination, setPagination ] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    const toggleForm = () => {
        setIsForm(!isForm);
        if(isForm == false){
            getAllCouriers();
        }
    }

    const getAllCouriers = async () => {
        const { success, data } = await get(`${COURIER}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if(success){
            setCouriers(data);
        }
    }

    useEffect(() => {
        const fetchData = setTimeout(() => {
            getAllCouriers();
        }, 500);

        return () => clearTimeout(fetchData);
    }, [pagination.page, pagination.limit, pagination.search]);

    const handleRemove = async (id, status) => {
        const { success, data } = await get(`${COURIER}/${id}?status=${status}`);
        if(success){
            getAllCouriers();
        }
    }

    const CourierColumns = [
        {
            dataField: 'id',
            text: '#',
            formatter: (cell, row, rowIndex, formatExtraData) => (pagination.page-1) * pagination.limit + (rowIndex+1)
        }, {
            dataField: 'name',
            text: 'role'
        }, {
            dataField: 'description',
            text: 'Description'
        }, {
            dataField: 'actions',
            text: "",
            isDummyField: true,
            formatter: (cell, row) => <>
                <button 
                    className={`btn btn-${row.status == 0 ? "danger" : "success"} btn-sm`}
                    onClick={() => handleRemove(row.id, row.status == 1 ? 0 : 1)}
                    title={row.status == 0 ? 'Deactivate' : 'Activate'}
                >
                    {row.status == 0 ? 'Deactivate' : 'Activate'}
                </button>
            </>
        }
    ];


    return (
        isForm ? <CourierForm cb={toggleForm} /> :
            <Datatables 
                isSearch={true}
                columns = {CourierColumns}
                showTableOnly={true}
                rowsLength={couriers?.totalRows || 0}
                rows = {couriers?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}            
                title = "All Courier Patners"
                loading = {false}
                isAdd = {true}
                isTableHead = {true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Couriers;